import {
  informationsAdd,
  selContentDetailByAdId,
  selContentList
} from '../../api/index'

export default {
  namespaced: true,
  actions: {
    async informationsAdd(context, arg) { //留言添加功能
      const response = await informationsAdd(arg);
      return response;
    },
    async selContentDetailByAdId(context, arg) { //
      const response = await selContentDetailByAdId(arg);
      return response.data;
    },
    async selContentList(context, arg) { //
      const response = await selContentList(arg);
      return response.data;
    }
  }
}